import { RULES } from '../config/competition'
import type { CompetitionState } from '../core/types'

/** The shape every panel renders before a single byte of data has arrived. */
export function emptyState(): CompetitionState {
  const now = Date.now()
  return {
    meta: {
      round: RULES.round,
      phase: 'standby',
      startedAt: now,
      endsAt: now + RULES.durationHours * 3600_000,
      seedCapital: RULES.seedCapital,
      status: 'connecting',
      source: 'mock',
      prices: 'offline',
      priceSource: '',
      tick: 0,
    },
    quotes: [],
    portfolios: {},
    positions: [],
    trades: [],
    thoughts: [],
    equity: [],
    leaderboard: [],
    houses: [],
    version: 0,
  }
}
